module.exports = "<ul class=\"search-suggestions-list\" *ngIf=\"(_filteredSuggestions$| async) as list\">\n  <li class=\"suggestion-item\" *ngFor=\"let item of list\" (click)=\"onSuggestionClick(item.value)\">\n    {{item.value}} <span class=\"property\">({{getProp(item.prop)}})</span>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/search-suggestions/search-suggestions.component.html
// module id = ./src/app/common/search-suggestions/search-suggestions.component.html
// module chunks = main